import { UniversalConfig } from '@application/universal_config.service';
import { Auth } from '@feature/auth/auth.component';
import { useResolve } from '@visiba/instantiation';

interface Props {}

export function ViewSignIn(_: Props): JSX.Element {
	const universalConfig = useResolve(UniversalConfig);

	return <Auth.Methods returnUrl={universalConfig.alias} />;
}
